<template>
  <div class="page-container">
    <div class="page_title">
      <div class="page_title_desc">电话通知流水查询</div>
    </div>
    <el-divider></el-divider>
    <el-form :inline="true" :model="filterForm" size="small">
      <el-form-item label>
        <el-input
          clearable
          v-model="filterForm.driverName"
          placeholder="请输入司机姓名"
        ></el-input>
      </el-form-item>
      <el-form-item label>
        <el-input
          clearable
          v-model="filterForm.driverPhone"
          placeholder="请输入手机号"
        ></el-input>
      </el-form-item>
      <el-form-item label>
        <el-date-picker
          v-model="filterForm.createTime"
          type="daterange"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="更新时间开始时间"
          end-placeholder="更新时间结束时间"
        ></el-date-picker>
      </el-form-item>
      <el-form-item>
        <kt-button
          icon="fa fa-search"
          label="搜索"
          perms="-1"
          type="primary"
          @click="handleSearch"
        />
      </el-form-item>
      <el-form-item>
        <kt-button
          icon="fa fa-share"
          label="重置"
          perms="-1"
          @click="handleReset"
          type="primary"
        />
      </el-form-item>
      <el-form-item>
        <kt-button
          icon="fa fa-jpy"
          label="手动补扣次数"
          perms="-1"
          type="primary"
          @click="handleShowDialog"
        />
      </el-form-item>
    </el-form>
    <el-table :data="noticeList" stripe size="small" style="width: 100%">
      <el-table-column
        label="序号"
        width="50"
        align="center"
        fixed
        type="index"
      ></el-table-column>
      <el-table-column
        label="司机姓名"
        align="center"
        width="120"
        prop="driverName"
      ></el-table-column>
      <el-table-column
        label="司机手机号"
        align="center"
        width="120"
        prop="driverPhone"
      ></el-table-column>
      <el-table-column
        label="通知次数变更"
        align="center"
        width="120"
        prop="changeCount"
      ></el-table-column>
      <el-table-column
        label="剩余次数"
        align="center"
        prop="remainingCount"
      ></el-table-column>
      <el-table-column
        label="更新时间"
        align="center"
        prop="updateTime"
      ></el-table-column>
      <el-table-column
        label="操作人"
        align="center"
        prop="updateUser"
      ></el-table-column>
      <el-table-column label="备注" align="center" prop="remark">
        
      </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="total, prev, pager, next"
      @current-change="refreshPageRequest"
      :current-page="pageNo"
      :page-size="pageSize"
      :total="totalSize"
      style="float: right;padding: 10px;"
    ></el-pagination>
    <el-dialog :visible.sync="isShowDialog" v-if="isShowDialog" width="450px" title="手动补扣次数" :close-on-click-modal="false" @close="handleCancel">
      <el-form :model="dataForm" label-width="150px" label-position="left" size="small">
        <el-form-item label="手机号：">
          <el-input v-model="dataForm.driverPhone" placeholder="请输入手机号" clearable style="width:150px" :disabled="!!dataForm.driverNo"></el-input>
          <kt-button
            icon="fa fa-search"
            v-if="!dataForm.driverNo"
            label="查找"
            perms="-1"
            type="primary"
            style="margin-left: 10px"
            @click="handleSearchPhone"
          />
        </el-form-item>
        <el-form-item label="司机姓名：" v-if="dataForm.driverNo">
          <span>{{dataForm.driverName}}</span>
        </el-form-item>
        <el-form-item label="电话通知剩余次数：" v-if="dataForm.driverNo">
          <span>{{dataForm.remainingCount}}</span>
        </el-form-item>
        <el-form-item label="变更次数：" v-if="dataForm.driverNo">
          <el-input-number v-model="dataForm.changeCount"  size="small" controls-position="right" :min="-dataForm.remainingCount"></el-input-number>
        </el-form-item>
        <el-form-item label="原因：" v-if="dataForm.driverNo">
          <el-input
              v-model="dataForm.remark"
              type="textarea"
              placeholder="请输入原因，20个字以内"
              maxlength="20"
              show-word-limit
            ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" v-if="dataForm.driverNo">
        <el-button size="small" @click="handleCancel">取消</el-button>
        <el-button size="small" type="primary" @click="handleConfirm">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import KtButton from '../../components/Core/KtButton.vue';
export default {
  data() {
    return {
      filterForm: {},
      pageNo: 1,
      pageSize: 10,
      totalSize: null,
      noticeList:[],
      isShowDialog: false,
      dataForm: {
      }
    };
  },
  components:{
    KtButton
  },
  mounted() {
    this.getNoticeList()
  },
  methods: {
    handleSearch() {
      this.pageNo = 1;
      this.getNoticeList();
    },
    handleCancel(){
      this.dataForm = {}
      this.isShowDialog = false
    },
    async handleConfirm(){
      if(!this.dataForm.driverPhone){
        this.$message({
          type:'error',
          message:'请先输入并查找司机',
          offset: 300
        })
        return
      }
      if(!this.dataForm.driverNo){
        this.$message({
          type:'error',
          message:'请先输入并查找司机',
          offset: 300
        })
        return
      }
      if(!this.dataForm.remark){
        this.$message({
          type:'error',
          message:'请输入原因',
          offset:300
        })
        return
      }
      let res = await this.$api.phoneService.manualSubtract({
        ...this.dataForm
      })
      this.$message({
        type:'success',
        offset:300,
        message: '操作成功'
      })
      this.getNoticeList()
      this.isShowDialog = false
      this.dataForm = {} 

    },
    async handleSearchPhone(){
      if(!/^\d{11}$/.test(this.dataForm.driverPhone)){
        this.$message({
          type:'error',
          message:'请输入正确手机号',
          offset: 300
        })
        return
      } 
      let res = await this.$api.phoneService.mGetDriverInfo({
        driverPhone: this.dataForm.driverPhone
      })
      if(!res.data.driverNo){
        this.$message({
          type:'error',
          message: '没有查询到该司机',
          offset: 300
        })
        return
      }
      let form ={
        driverName: res.data.driverName ,
        remainingCount : res.data.remainingCount,
        driverPhone: res.data.driverPhone || this.dataForm.driverPhone,
        driverNo: res.data.driverNo ,
        changeCount: 0,
        remark :''
      }
      this.dataForm = form
    },
    handleReset() {
      this.pageNo =1
      this.filterForm = {}
      this.getNoticeList()
    },
    handleShowDialog() {
      this.isShowDialog = true
    },
    async getNoticeList() {
      let params = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      };
      let form = { ...this.filterForm };
      let index = 0;
      for (let key in form) {
        const val = form[key];
        if (val === 0 || (val !== "" && val)) {
          params["searchFieldList[" + index + "].fieldName"] = key;
          if (key === "createTime") {
            params[
              "searchFieldList[" + index + "].rangeMinValue"
            ] = `${val[0]} 00:00:00`;
            params[
              "searchFieldList[" + index + "].rangeMaxValue"
            ] = `${val[1]} 23:59:59`;
          } else {
            params["searchFieldList[" + index + "].singleValue"] = val;
          }
          index++;
        }
      }
      let res = await this.$api.phoneService.mGetSearchList(params)
      this.noticeList = res.data.dtoList ||[]
      this.totalSize = res.data.totalSize
    },
    refreshPageRequest(val){
      this.pageNo = val
      this.getNoticeList()
    }
  },
};
</script>

<style lang="scss" scoped>
.page-container{
  box-sizing: border-box;
  padding: 10px;
}
</style>